import { type TreatmentCategory } from '@/consts/treatmentCategories';

export const appUrls = {
  visit: {
    flow: (uuid: string) => `/v/${uuid}` as const,
    auth: (uuid: string) => `/v/auth/${uuid}` as const,
    status: (uuid: string) => `/v/status/${uuid}` as const,
    start: (slug: string) => `/v/start/${slug}` as const,
    survey: (uuid: string, pageName?: string) =>
      `/c/${uuid}/${pageName}` as const,
  },
  checkout: '/checkout',
  dashboard: '/dashboard',
  findYourTreatment: '/find-your-treatment',
  hairRegistration: '/get-started/hair/register',
  guardian: `/guardian`,
  ineligible: <T extends TreatmentCategory>(treatmentCategory: T) =>
    `/ineligible/${treatmentCategory}` as const,
  newTreatmentFlow: <T extends TreatmentCategory>(treatmentCategory: T) =>
    `/new-treatment/${treatmentCategory}` as const,
  notFound: '/not-found',
  productSelection: '/product-selection',
  renewal: '/renewal',
  renewalNe: '/renewal-ne',
  signupFlow: <T extends TreatmentCategory>(treatmentCategory: T) =>
    `/get-started/${treatmentCategory}` as const,
  signupFlowEligibility: <T extends TreatmentCategory, Slug extends string>(
    treatmentCategory: T,
    slug?: Slug,
  ) => {
    if (slug) {
      return `/get-started/${treatmentCategory}/${slug}`;
    }

    return `/get-started/${treatmentCategory}/${treatmentCategory === 'hair' ? 'make-sure-youre-eligible' : 'welcome'}`;
  },
  signupOneTimeFlow: <T extends TreatmentCategory>(treatmentCategory: T) =>
    `/get-started-one-time/${treatmentCategory}` as const,
  signupOneTimeFlowEligibility: <
    T extends TreatmentCategory,
    Slug extends string,
  >(
    treatmentCategory: T,
    slug?: Slug,
  ) => {
    if (slug) {
      return `/get-started-one-time/${treatmentCategory}/${slug}` as const;
    }

    return `/get-started-one-time/${treatmentCategory}/quiz` as const;
  },
  skinCompleteSignup: '/get-started/skin/all-set',
  skinSurvey: '/start/skin',
  survey: (pageName: string) => {
    return `/survey/${pageName}`;
  },
} as const;
